import { theme } from '@ketch-com/deck'
import { Box } from '@mui/material'
import { TopCollectorCard } from './TopCollectorCard'
import { EventsVolumeCard } from './EventsVolumeCard'
import { EventsOverTimeLineChart } from './EventsOverTimeLineChart'

export const DataSummaryWidget: React.FC = () => {
  return (
    <Box display="flex" height="168px" borderRadius={2} border={`1px solid ${theme.palette.Black.o8}`}>
      <Box flex="1">
        <TopCollectorCard />
      </Box>
      <Box flex="1" sx={{ borderInlineStart: '1px solid', borderColor: theme.palette.Black.o8 }}>
        <EventsVolumeCard />
      </Box>
      <Box flex="2">
        <EventsOverTimeLineChart />
      </Box>
    </Box>
  )
}
